import React from "react";

const tableStyle = {
  width: "100%",
  borderCollapse: "collapse",
  marginBottom: "30px",
  backgroundColor: "#fff",
  borderRadius: "6px",
  overflow: "hidden",
  boxShadow: "0 2px 6px rgba(0,0,0,0.1)"
};

const thStyle = {
  padding: "10px",
  backgroundColor: "#f4f4f4",
  borderBottom: "1px solid #ddd",
  textAlign: "left",
  fontWeight: 600
};

const tdStyle = {
  padding: "10px",
  borderBottom: "1px solid #eee",
  cursor: "pointer"
};

const rowHoverStyle = {
  backgroundColor: "#f9fafb"
};

// 3D LOOKING EMOJI DOTS
const getSignalDot = (signal) => {
  if (!signal) return "⚪";
  const s = signal.toLowerCase();

  if (s.includes("buy") || s.includes("long")) return "🟢";
  if (s.includes("sell") || s.includes("short")) return "🔴";
  if (s.includes("hold")) return "🔵";
  return "⚪";
};

const getConfidenceDot = (c) => {
  if (c == null) return "⚪";
  if (c >= 0.8) return "🟢";
  if (c >= 0.5) return "🟡";
  return "🔴";
};

const SignalTable = ({ moduleName, rows = [], onRowClick }) => {
  if (!rows || rows.length === 0) return null;

  return (
    <div style={{ marginBottom: "40px" }}>
      <h3 style={{ textTransform: "capitalize" }}>{moduleName}</h3>

      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>Symbol</th>
            <th style={thStyle}>Time</th>
            <th style={thStyle}>Signal</th>
            <th style={thStyle}>Confidence</th>
            <th style={thStyle}>More</th>
          </tr>
        </thead>

        <tbody>
          {rows.map((row, idx) => {
            const data = row.data || {};
            const signal = data.signal || data.signal_type || data.action || "-";
            const conf = data.confidence || data.conf || null;

            return (
              <tr
                key={idx}
                onClick={() => onRowClick(row)}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.backgroundColor = rowHoverStyle.backgroundColor)
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = "transparent")
                }
              >
                <td style={tdStyle}>{row.symbol}</td>

                <td style={tdStyle}>
                  {new Date(row.created_at).toLocaleTimeString()}
                </td>

                {/* SIGNAL + EMOJI DOT */}
                <td style={tdStyle}>
                  {getSignalDot(signal)}{" "}
                  <strong>{signal.toUpperCase()}</strong>
                </td>

                {/* CONFIDENCE + EMOJI DOT */}
                <td style={tdStyle}>
                  {conf ? (
                    <span style={{ fontSize: "14px" }}>
                      {getConfidenceDot(conf)}{" "}
                      {(conf * 100).toFixed(0)}%
                    </span>
                  ) : (
                    "-"
                  )}
                </td>

                <td style={tdStyle}>
                  <span style={{ color: "#2563eb" }}>View »</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default SignalTable;
